<template>
  <div>
    <b-modal v-bind:active.sync="modalActive" animation :width="400">
      <FloorModal />
    </b-modal>
    <div class="floors-box-label">
      FLOORS
    </div>
    <div class="columns is-multiline is-mobile is-8">
      <div
        class="column is-one-quarter-desktop is-half-touch is-narrow"
        v-for="floor in $store.getters.selectedBuilding.floors"
      >
        <div class="card">
          <a href="javascript:void(0)" @click="floor_clicked(floor)">
            <div class="card-image">
              <figure class="image thumbnail-image-placeholder">
                <img
                  class="thumbnail-image"
                  v-bind:src="floor.lo_res_url"
                  alt="Floor plan image"
                />
              </figure>
            </div>
          </a>
          <footer class="card-footer is-size-6-desktop is-size-7-touch">
            <a
              href="javascript:void(0)"
              @click="floor_clicked(floor)"
              class="card-footer-title"
            >
              <span class="card-title">{{ floor.name }}</span>
            </a>
            <div class="card-footer-menu">
              <b-dropdown class="end" position="is-bottom-left">
                <p
                  class="tag three-dots card-footer-three-dots is-white"
                  slot="trigger"
                  role="button"
                  aria-label="More options"
                >
                  <span class="icon">
                    <i class="fas fa-ellipsis-h card-footer-icon"></i>
                  </span>
                </p>

                <b-dropdown-item
                  id="rename-button"
                  aria-role="listitem"
                  is-danger
                  @click="renameFloorClicked(floor)"
                  aria-label="Rename floor"
                >
                  <p class="is-vertical-center">
                    <b-icon icon="edit"></b-icon>Rename
                  </p>
                </b-dropdown-item>
                <b-dropdown-item
                  id="delete-button"
                  aria-role="listitem"
                  is-danger
                  @click="deleteFloorClicked(floor)"
                  aria-label="Delete floor"
                >
                  <p class="is-vertical-center">
                    <b-icon icon="trash"></b-icon>Delete
                  </p>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </footer>
        </div>
      </div>
      <div class="column is-one-quarter-desktop is-half-touch is-narrow">
        <div class="card">
          <a href="javascript:void(0)" @click="clickedAddNewFloor()" class="">
            <figure class="card-image new-card-image image is-5by3">
              <img
                src="../assets/plus_sign_custom2.png"
                alt="Floor plan image"
              />
            </figure>
            <footer
              class="card-footer new-card-footer is-size-6-desktop is-size-7-touch"
            >
              <strong class="card-footer-title new-card-title"
                >Add new floor</strong
              >
            </footer>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FloorModal from "@/components/FloorModal.vue";
import { Dialog } from "buefy/dist/components/dialog";
import { deleteFloor, renameFloor } from "../api-requests";
export default {
  name: "FloorCardsBox",
  components: { FloorModal },
  data: function() {
    return {
      modalActive: false,
      droppedFile: undefined
    };
  },
  methods: {
    clickedAddNewFloor: function(x) {
      console.log("Called addNewFloor");
      this.modalActive = true;
    },
    floor_clicked: function(floor) {
      // console.log(floor)
      this.$store.commit("SET_SELECTED_FLOOR_ID", floor.id);
      this.$router.push("/locations");
    },
    deleteFloorClicked: function(floor) {
      console.log(floor);
      Dialog.confirm({
        message:
          "Are you sure you want to <b>delete</b> " +
          floor.name +
          "? This action cannot be undone.",
        type: "is-danger",
        hasIcon: true,
        icon: "exclamation-circle",
        iconPack: "fa",
        onConfirm: function(value) {
          console.log("Deleted the floor!");
          deleteFloor(floor.id);
        },
        confirmText: "Delete"
      });
    },
    renameFloorClicked: function(floor) {
      console.log(floor);
      Dialog.prompt({
        message: "Enter new name for this floor.",
        inputAttrs: {
          placeholder: "New floor name",
          maxlength: 100,
          value: floor.name
        },
        onConfirm: function(value) {
          console.log("Renamed the floor!");
          renameFloor(floor.id, value);
        },
        confirmText: "Rename"
      });
    }
  }
};
</script>

<style scoped>
.floors-box-label {
  color: #8e8e8e;
  font-weight: 600;
  font-size: 0.8rem;
  text-align: left;
  padding-bottom: 8px;
}

.card {
  border: 1px solid;
  border-color: lightgray;
  border-radius: 4px;
  box-shadow: 0 0 0;
  height: 100%;
}

.card:hover {
  border-color: #f40176;
  box-shadow: 3 3 3;
}

.image {
  opacity: 0.7;
  margin: 12px;
}

.thumbnail-image {
  max-height: 100%;
  width: auto;
  margin: auto;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
}

.thumbnail-image-placeholder {
  padding-top: 60%;
}

.card-title {
  color: gray;
  text-align: left;
  font-weight: 600;
}

.card-footer-title {
  display: flex;
  flex-basis: 0;
  flex-grow: 1;
  padding: 0.75rem;
}

@media (min-width: 768px) {
  .card-footer-menu {
    padding: 0.75rem;
    vertical-align: center;
  }
  .card-footer-three-dots {
    padding: 1px 5px 1px 5px;
  }
}
@media (max-width: 768px) {
  .card-footer-menu {
    vertical-align: center;
  }
}

.card-footer-three-dots:hover {
  background-color: #d3d3d347;
  border-radius: 20px;
}

.card-footer-icon {
  color: gray;
}

.new-card-image {
  position: relative;
  top: 8px;
  margin: 12px auto;
}

.new-card-footer {
  border-top: 1px solid white;
}

.new-card-title {
  display: flex;
  color: gray;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.dummy {
  background-color: gray;
}
.button {
  border-width: 1px;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
}

::-webkit-scrollbar:vertical {
  width: 12px;
}

::-webkit-scrollbar:horizontal {
  height: 12px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  border: 2px solid #ffffff;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #ffffff;
}
</style>
